import React from "react";
import MainContainer from "src/Component/grid-component/MainContainer";
import ImageContainer from "src/Component/grid-component/ImageContainer";
import ContentContainer from "src/Component/grid-component/ContentContainer";
import Header from "src/Component/content-component/Header";
import ParaData from "src/Component/content-component/ParaData";
import { Box } from "@mui/material";

const ImmersionTabUniversity = ({ regionData }) => {
  
  if (!regionData) {
    return null;
  }

  return (
    <>{regionData &&
      Array.isArray(regionData) ? (
        regionData.map((university, index) => (
          <MainContainer
            key={index}
            dir="column-reverse"
            color={"#EFFDFF"}
            com1={<ImageContainer img={university.image} />}
            com2={
              <ContentContainer
                Header={<Header content={university.title} />}
                Content={
                  <>
                    {typeof university.content === "string" ? (
                      <ParaData
                        color={"#525560"}
                        fontSize={"16px"}
                        content={university.content}
                      />
                    ) : (
                      <>
                        <ParaData
                          color={"#525560"}
                          fontSize={"16px"}
                          content={university.content.university}
                        />
                        <ul>
                          {university.content.highlights.map((highlight, i) => (
                            <li key={i}>{highlight}</li>
                          ))}
                        </ul>
                      </>
                    )}
                  </>
                }
              />
            }
          />
        ))
      ) : (
        <>
          <MainContainer
            dir="column-reverse"
            color={"#EFFDFF"}
            com1={<ImageContainer img={regionData.image} />}
            com2={
              <ContentContainer
                Header={<Header content={regionData.title} />}
                Content={
                  <>
                    {typeof regionData.content === "string" ? (
                      <ParaData
                        color={"#525560"}
                        fontSize={"16px"}
                        content={regionData.content}
                      />
                    ) : (
                      <>
                        <ParaData
                          color={"#525560"}
                          fontSize={"16px"}
                          content={regionData.content.university}
                        />
                        <ul>
                          {regionData.content.highlights.map((highlight, i) => (
                            <li key={i}>{highlight}</li>
                          ))}
                        </ul>
                      </>
                    )}
                  </>
                }
              />
            }
          />

          {regionData.companyVisit && <MainContainer
            dir="column-reverse"
            color={"#EFFDFF"}
            com2={<ImageContainer img={regionData.companyVisit.image} />}
            com1={
              <ContentContainer
                Header={<Header content="Company Visit" />}
                Content={
                  <>
                    {typeof regionData.companyVisit === "string" ? (
                      <ParaData
                        color={"#525560"}
                        fontSize={"16px"}
                        content={regionData.companyVisit}
                      />
                    ) : (
                      <>
                        <ParaData
                          color={"#525560"}
                          fontSize={"16px"}
                          content={regionData.companyVisit.subHeading}
                        />
                        <ul>
                          {regionData.companyVisit.points.map((highlight, i) => (
                            <li key={i}>{highlight}</li>
                          ))}
                        </ul>
                      </>
                    )}
                  </>
                }
              />
            }
          />}
        </>
      )
}
      {regionData.cityCultureImages && (
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          height="auto"
          width="100%"
          paddingTop="20px"
        >
          <Box
            width={{ xs: "100%", md: "30%" }}
            height="auto"
            display="flex"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            p={4}
            sx={{
              backgroundColor: "#00999e",
              color: "white",
              textTransform: "uppercase",
              fontSize: { xs: "1.5rem", md: "2.5rem" },
              fontWeight: "bold",
            }}
          >
            Cultural Exploration
          </Box>
          <Box
            width={{ xs: "100%", md: "70%" }}
            display="flex"
            flexWrap="wrap"
            justifyContent="space-between"
            p={3}
          >
            {regionData.cityCultureImages.map((image, index) => (
              <Box
                key={index}
                width={{ xs: "100%", md: "32%" }}
                mb={2}
                height={{ xs: "150px", md: "200px" }}
                overflow="hidden"
                boxShadow={4}
                sx={{
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};

export default ImmersionTabUniversity;
